import type {InputHTMLAttributes, SelectHTMLAttributes} from 'react'
import {cn} from '../../lib/utils'

const FIELD_CLASSES =
    'font-mono text-sm border-b-2 border-foreground/30 bg-transparent px-0 py-1.5 text-foreground focus:outline-none focus:border-primary'

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>

export function UnderlineSelect({className, children, ...rest}: SelectProps) {
    return (
        <select
            {...rest}
            className={cn(FIELD_CLASSES, 'pr-8 appearance-none cursor-pointer', className)}
        >
            {children}
        </select>
    )
}

type InputProps = InputHTMLAttributes<HTMLInputElement>

export function UnderlineInput({className, ...rest}: InputProps) {
    return (
        <input
            {...rest}
            className={cn(FIELD_CLASSES, className)}
        />
    )
}
